<template>
  <div>
    <v-card tile elevation="0" class="item-card">
      <v-container fluid>
        <v-row justify="space-between">
          <v-col cols="6" sm="3">
            <general-button btn_type="info" btn_block @click-event="onSubmit"
              ><template v-slot:icon
                ><v-icon left>mdi-content-save</v-icon></template
              >保存</general-button
            >
          </v-col>
          <v-col cols="6" sm="3">
            <general-button
              btn_type="info"
              btn_block
              @click-event="addPriceCard"
              :btn_disabled="price_table.length >= 10"
              ><template v-slot:icon><v-icon left>mdi-plus</v-icon></template
              >料金表を追加</general-button
            >
          </v-col>
        </v-row>
      </v-container>
      <div class="pa-2">
        <h3>料金情報の設定</h3>
        <div class="mt-2 mb-2">
          <div>
            料金ページに掲載したい場合、入力してください。最大10個まで料金表を設定可能です。
          </div>
        </div>
        <div class="mb-4 d-flex flex-wrap flex-sm-nowrap">
          <div
            v-for="(room, c_index) in price_table"
            :key="c_index"
            @click="scrollToRoom(c_index)"
            class="pa-2 mr-2 cursor-pointer text-subtitle-1 blue--text"
          >
            料金表 {{ c_index + 1 }}
          </div>
          <div
            v-if="price_table.length === 0"
            class="pa-2 text-subtitle-1 red--text"
          >
            料金表を追加してください。
          </div>
        </div>
        <ValidationObserver ref="observer">
          <div v-for="(price, c_index) in price_table" :key="c_index">
            <div
              :id="'price_table_id' + c_index"
              class="price_table-title d-flex align-center mb-2"
            >
              <h3>料金表 {{ c_index + 1 }}</h3>
              <v-btn
                icon
                small
                class="ml-2"
                :disabled="c_index === 0"
                @click="movePriceUp(c_index)"
                ><v-icon>mdi-chevron-up</v-icon></v-btn
              >
              <v-btn
                icon
                small
                :disabled="c_index === price_table.length - 1"
                @click="movePriceDown(c_index)"
                ><v-icon>mdi-chevron-down</v-icon></v-btn
              >
              <v-btn icon small @click="removePriceCard(c_index)"
                ><v-icon>mdi-delete</v-icon></v-btn
              >
            </div>
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <div class="font-weight-bold mb-2">料金表タイトル</div>
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    :name="price.price_title.name"
                    rules="required|max:255"
                  >
                    <v-text-field
                      v-model="price.price_title.detail"
                      :name="price.price_title.category_code"
                      :label="price.price_title.name"
                      :error-messages="errors"
                      :success="valid"
                      outlined
                      hint="必須項目です。料金表のタイトルを入力してください。"
                      persistent-hint
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="font-weight-bold mb-2">明細表</div>
                  <div class="mt-2 mb-2">
                    入力した内容がそのまま料金ページに反映されます。
                    <v-btn
                      text
                      color="primary"
                      class="font-weight-bold pa-1 d-inline"
                      @click="addPriceDetail(price)"
                    >
                      明細行を追加
                    </v-btn>
                  </div>
                  <div
                    v-for="(item, index) in price.price_detail"
                    :key="index"
                    class="d-flex flex-row align-center mb-2"
                  >
                    <div class="price-detail d-flex flex-row mr-2">
                      <v-text-field
                        class="mr-2"
                        v-model="item.name"
                        :name="item.category_code + '_name_' + index"
                        :label="'明細' + (index + 1)"
                        :success="true"
                        outlined
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        v-model="item.detail"
                        :name="item.category_code + '_detail_' + index"
                        :label="'明細' + (index + 1) + 'の金額等'"
                        :success="true"
                        outlined
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="price-button d-flex flex-row">
                      <v-btn
                        icon
                        small
                        :disabled="index === 0"
                        @click="movePriceDetailUp(price, index)"
                        ><v-icon class="price-detail-icon"
                          >mdi-chevron-up</v-icon
                        ></v-btn
                      >
                      <v-btn
                        icon
                        small
                        :disabled="index === price.price_detail.length - 1"
                        @click="movePriceDetailDown(price, index)"
                        ><v-icon class="price-detail-icon"
                          >mdi-chevron-down</v-icon
                        ></v-btn
                      >
                      <v-btn icon small @click="removePriceDetail(price, index)"
                        ><v-icon class="price-detail-icon"
                          >mdi-delete</v-icon
                        ></v-btn
                      >
                    </div>
                  </div>
                  <div
                    v-if="price.price_detail.length === 0"
                    class="pa-2 text-subtitle-1 red--text"
                  >
                    明細行を追加してください。
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="font-weight-bold">備考欄</div>
                  <div class="mt-2 mb-2">
                    <v-btn
                      text
                      color="primary"
                      class="font-weight-bold pa-1 d-inline"
                      @click="onHtmlClear(c_index)"
                      >HTMLをクリア</v-btn
                    >
                    <p class="mini text-red">
                      ※GoogleMapやバナー等のHTMLを使用する際は「ソース」をクリックしてから、HTMLを貼り付け、再度「ソース」をクリックして元の画面に戻ってから保存してください。
                    </p>
                  </div>
                  <v-card tile elevation="0" class="mb-6">
                    <div class="ma-3">
                      <ckeditor-component
                        :ref="price.price_html.ref"
                        :data="price.price_html.detail"
                      ></ckeditor-component>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
            <v-divider class="mt-4 mb-4"></v-divider>
          </div>
        </ValidationObserver>
      </div>
      <v-container fluid>
        <v-row justify="space-between">
          <v-col cols="6" sm="3">
            <general-button btn_type="info" btn_block @click-event="onSubmit"
              ><template v-slot:icon
                ><v-icon left>mdi-content-save</v-icon></template
              >保存</general-button
            >
          </v-col>
          <v-col cols="6" sm="3">
            <general-button
              btn_type="info"
              btn_block
              @click-event="addPriceCard"
              :btn_disabled="price_table.length >= 10"
              ><template v-slot:icon><v-icon left>mdi-plus</v-icon></template
              >料金表を追加</general-button
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import {
  ref,
  set,
  reactive,
  toRefs,
  defineComponent,
  watch,
  onMounted,
} from "@vue/composition-api";
import store from "@/store/index.js";
import { repositoryFactory } from "@/repository/repositoryFactory";
import setting from "@/common/setting.js";
import imageUploaderComponent from "./imageUploader.vue";
import retryRequest from "@/common/retryRequest";

export default defineComponent({
  components: {
    imageUploaderComponent,
  },
  props: ["shop_site_id"],
  setup(props, ctx) {
    const HpListDetailRepository = repositoryFactory.get("hpListDetails");

    const data_id = 2; // 料金設定 2固定
    const state = reactive({
      // 入力項目カテゴリごとのデータ構造体
      price_table: [],
    });
    const category_items = {
      price_title: {
        type: "text",
        ref: "refPriceTitle",
        category_num: 0,
        category_code: "price_title",
        name: "料金タイトル",
        detail: "",
        sort: 0,
      },
      price_detail: [
        {
          type: "text",
          ref: "refPriceDetail",
          category_num: 0,
          category_code: "price_detail",
          name: "",
          detail: "",
          sort: 1,
        },
        {
          type: "text",
          ref: "refPriceDetail",
          category_num: 0,
          category_code: "price_detail",
          name: "",
          detail: "",
          sort: 2,
        },
        {
          type: "text",
          ref: "refPriceDetail",
          category_num: 0,
          category_code: "price_detail",
          name: "",
          detail: "",
          sort: 3,
        },
      ],
      price_html: {
        type: "html",
        ref: "refPriceHtml",
        category_num: 0,
        category_code: "price_html",
        name: "コメント HTML",
        detail: "",
        sort: 9999,
      },
    };

    const getListData = async () => {
      // サイト設定データ取得
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      const params = {
        shop_site_id: props.shop_site_id,
        data_id: data_id,
      };
      const response = await retryRequest(
        HpListDetailRepository.list_data,
        params,
        true
      );
      if (response.data) {
        if (response.data.length === 0) {
          // データがない場合は何もしない
        } else {
          // 取得したデータをstateにセット
          let tmpPriceTable = {};
          let tmpPriceDetail = [];
          let tmpPriceHtml = {};
          let keepCategoryNum = 0;
          for (const getItem of response.data) {
            if (keepCategoryNum !== getItem.category_num) {
              // カテゴリ番号が変わった場合は新しい料金表を作成
              if (tmpPriceTable.category_num !== undefined) {
                state.price_table.push({
                  price_title: tmpPriceTable,
                  price_detail: tmpPriceDetail,
                  price_html: tmpPriceHtml,
                });
              }
              tmpPriceTable = {};
              tmpPriceDetail = [];
              tmpPriceHtml = {};
              keepCategoryNum = getItem.category_num;
            }
            if (getItem.category_code === "price_title") {
              tmpPriceTable = {
                ...category_items[getItem.category_code],
                category_num: getItem.category_num,
                name: getItem.name,
                detail: getItem.detail,
                sort: getItem.sort,
              };
            } else if (getItem.category_code === "price_html") {
              tmpPriceHtml = {
                ...category_items[getItem.category_code],
                category_num: getItem.category_num,
                name: getItem.name,
                detail: getItem.detail,
                sort: getItem.sort,
              };
            } else if (getItem.category_code === "price_detail") {
              const detailItem = {
                ...category_items[getItem.category_code][0],
                category_num: getItem.category_num,
                name: getItem.name,
                detail: getItem.detail,
                sort: getItem.sort,
              };
              tmpPriceDetail.push(detailItem);
            }
          }
          state.price_table.push({
            price_title: tmpPriceTable,
            price_detail: tmpPriceDetail,
            price_html: tmpPriceHtml,
          });
        }
      }

      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");
    };

    onMounted(() => {
      getListData();
    });

    const onSubmit = async () => {
      // 入力チェック エラー状態の部品が無いか調べる
      const isValid = await ctx.refs.observer.validate();

      if (!isValid) {
        // エラー処理
        const el = document.querySelectorAll(
          ".v-text-field.error--text, .v-textarea.error--text"
        );
        if (el.length > 0) {
          el[0].scrollIntoView();
          window.scrollBy(0, -80);
        }
        return;
      } else {
        // サイト設定保存処理
        if (!window.confirm("保存してよろしいですか？")) {
          return false;
        }

        store.dispatch("loadingIcon/showIcon"); // ローディング表示

        const save_list = [];

        let index = 0;
        for (const card of state.price_table) {
          for (const key in card) {
            if (key === "price_title" || key == "price_html") {
              if (key == "price_html") {
                // HTMLの場合はCKEditorの内容を取得
                card[key].detail = ctx.refs[card[key].ref][index].editorData;
              }
              save_list.push({
                shop_site_id: props.shop_site_id,
                data_id: data_id,
                category_num: index + 1,
                category_code: card[key].category_code,
                name: card[key].name,
                detail: card[key].detail,
                sort: card[key].sort,
              });
            } else if (key === "price_detail") {
              // 明細行の場合はループして保存
              let sortIndex = 1;
              for (const detail of card[key]) {
                save_list.push({
                  shop_site_id: props.shop_site_id,
                  data_id: data_id,
                  category_num: index + 1,
                  category_code: detail.category_code,
                  name: detail.name,
                  detail: detail.detail,
                  sort: sortIndex,
                });
                sortIndex++;
              }
            }
          }
          index++;
        }
        const params = {
          shop_site_id: props.shop_site_id,
          data_id: data_id,
          save_list: save_list,
        };
        await HpListDetailRepository.save_list(params)
          .then((response) => {
            if (response.data) {
              // 保存OK
              alert("料金情報を保存しました。");
            }
          })
          .catch((error) => {
            throw "ERROR:HpListDetailRepository.save_list (" + error + ")";
          });

        // ローディング非表示
        store.dispatch("loadingIcon/hideIcon");
        ctx.refs.observer.reset();
      }
    };

    const onHtmlClear = (card_index) => {
      if (
        !window.confirm("HTMLに入力された内容をクリアします。よろしいですか？")
      ) {
        return;
      }
      state.price_table[card_index].price_html.detail = ""; // HTML内容をクリア
      ctx.refs[state.price_table[card_index].price_html.ref][
        card_index
      ].editorData = ""; // CKEditorの内容もクリア
    };

    const scrollToRoom = (c_index) => {
      const el = document.getElementById("price_table_id" + c_index);
      if (el) el.scrollIntoView({ behavior: "auto" });
    };

    // ルーム情報の上下入れ替え
    const movePriceUp = (index) => {
      if (index > 0) {
        const tmp = state.price_table[index - 1];
        set(state.price_table, index - 1, state.price_table[index]);
        set(state.price_table, index, tmp);
        scrollToRoom(index - 1); // 上に移動した場合はスクロール
      }
    };
    const movePriceDown = (index) => {
      if (index < state.price_table.length - 1) {
        const tmp = state.price_table[index + 1];
        set(state.price_table, index + 1, state.price_table[index]);
        set(state.price_table, index, tmp);
        scrollToRoom(index + 1); // 下に移動した場合はスクロール
      }
    };

    // 明細の上下入れ替え
    const movePriceDetailUp = (price, index) => {
      if (index > 0) {
        const tmp = price.price_detail[index - 1];
        price.price_detail.splice(index - 1, 1, price.price_detail[index]);
        price.price_detail.splice(index, 1, tmp);
      }
    };
    const movePriceDetailDown = (price, index) => {
      if (index < price.price_detail.length - 1) {
        const tmp = price.price_detail[index + 1];
        price.price_detail.splice(index + 1, 1, price.price_detail[index]);
        price.price_detail.splice(index, 1, tmp);
      }
    };
    // 明細の削除
    const removePriceDetail = (price, index) => {
      price.price_detail.splice(index, 1);
    };
    // 明細行追加
    const addPriceDetail = (price) => {
      price.price_detail.push({
        type: "text",
        ref: "refPriceDetail",
        category_num: 0,
        category_code: "price_detail",
        name: "",
        detail: "",
        sort: price.price_detail.length + 1,
      });
    };

    // 料金表追加
    const addPriceCard = () => {
      const newPrice = {
        price_title: {
          ...category_items.price_title,
        },
        price_detail: category_items.price_detail.map((item) => ({
          ...item,
        })),
        price_html: {
          ...category_items.price_html,
        },
      };
      state.price_table.push(newPrice);
    };

    // 料金表削除
    const removePriceCard = (index) => {
      if (!window.confirm("料金表を削除します。よろしいですか？")) {
        return;
      }
      state.price_table.splice(index, 1);
    };

    // 返却オブジェクト定義
    return {
      setting,
      ...toRefs(state),
      onSubmit,
      onHtmlClear,
      scrollToRoom,
      movePriceUp,
      movePriceDown,
      removePriceCard,
      addPriceCard,
      movePriceDetailUp,
      movePriceDetailDown,
      removePriceDetail,
      addPriceDetail,
    };
  },
});
</script>

<style scoped>
.price_table-title {
  margin-top: -30px;
  padding-top: 50px;
  margin-bottom: 10px;
  font-weight: bold;
}
</style>
<style scoped>
@media (max-width: 600px) {
  .price-detail-icon {
    font-size: 18px !important;
  }
}
</style>
